import React from 'react';

import { ApplyData } from '../types';
import screenTypeTelemetry from './Screens/ScreenTypes/screenTypeTelemetry';
import { STRING_CLOSE } from '../labels';

import './CloseButton.less';

interface CloseButtonProps {
  applicationState: string;
  applyData: ApplyData;
  handleCloseModal: () => void;
  isLoading: boolean;
  screenType: string;
  toggleWarningModal: () => void;
}

export function CloseButton({
  applicationState,
  applyData,
  handleCloseModal,
  isLoading,
  screenType,
  toggleWarningModal,
}: CloseButtonProps): React.ReactNode {
  const closeModal = () => {
    if (screenType === 'collect_email_address') {
      // If we're on the CollectEmailAddress step, that means we've not started the application process
      // So when we close the modal, we should not see the warning modal
      applyData.onDone?.(applicationState);
      handleCloseModal();
    } else {
      toggleWarningModal();
    }

    // Log that the JobSeeker decided to close the modal
    const { logInteraction } = screenTypeTelemetry(screenType, applyData);
    logInteraction('close');
  };
  return (
    <button type="button" className="close_modal_button" aria-label={STRING_CLOSE} onClick={closeModal} disabled={isLoading} />
  );
}
